import useDataLoader from './useDataLoader';


export default () => useDataLoader('/rest/webmaster/zip', 'zip');
